import React from "react";

export default function Privacy() {
  const updated = new Date().toISOString().slice(0, 10);
  return (
    <div className="max-w-3xl mx-auto p-6 text-sm leading-6">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p className="text-xs opacity-70 mb-6">Last updated: {updated}</p>

      <Section title="1. Introduction">
        <p>
          This Privacy Policy explains how we collect, use, and protect your
          information when you use the AstraTrade App. By using the AstraTrade
          App, you agree to the practices described here.
        </p>
      </Section>

      <Section title="2. Data We Collect">
        <ul className="list-disc pl-6">
          <li>
            Account data: username, email; authentication data such as hashed
            passwords and session tokens.
          </li>
          <li>
            Usage data: device information, IP address, timestamps, feature
            interactions, and event logs.
          </li>
          <li>
            Trading data: balances, positions, orders/transactions, and related
            metadata necessary to operate the service.
          </li>
        </ul>
      </Section>

      <Section title="3. How We Use Data">
        <ul className="list-disc pl-6">
          <li>Provide, operate, and secure the AstraTrade App.</li>
          <li>Authenticate users and manage sessions.</li>
          <li>Process funding and withdrawals, and send service notifications.</li>
          <li>Improve functionality and user experience (analytics).</li>
          <li>Comply with legal obligations (e.g., KYC/AML where applicable).</li>
        </ul>
      </Section>

      <Section title="4. Legal Bases (where applicable)">
        <p>
          We rely on various legal bases, including performance of a contract,
          legitimate interests (security, quality, and analytics), consent (for
          optional communications), and legal obligations.
        </p>
      </Section>

      <Section title="5. Sharing and Disclosure">
        <p>
          We may share data with service providers (hosting, email, analytics)
          under contract; with regulators or law enforcement if required by law;
          and in connection with business transfers. We do not sell your personal
          information.
        </p>
      </Section>

      <Section title="6. Data Retention">
        <p>
          We retain information as long as reasonably necessary to provide the
          service, comply with legal obligations, resolve disputes, and enforce
          agreements. Retention periods vary by data type and legal requirements.
        </p>
      </Section>

      <Section title="7. Security">
        <p>
          We implement reasonable technical and organizational measures to protect
          your data. No method of transmission or storage is 100% secure; you are
          responsible for maintaining strong credentials and safeguarding your
          account.
        </p>
      </Section>

      <Section title="8. International Transfers">
        <p>
          Your data may be processed in other countries. Where required, we use
          appropriate safeguards for cross‑border transfers.
        </p>
      </Section>

      <Section title="9. Your Rights">
        <p>
          Subject to local law, you may have rights to access, correct, delete,
          restrict, or object to processing of your data, and to data portability.
          To exercise these rights, contact us at
          {" "}
          <a
            href="mailto:support@astratrade.io"
            className="text-blue-500 underline"
          >
            support@astratrade.io
          </a>
          .
        </p>
      </Section>

      <Section title="10. Cookies and Tracking">
        <p>
          We use session tokens/local storage to keep you signed in and support
          core functionality. Optional analytics cookies (if enabled) can be
          controlled through your browser settings.
        </p>
      </Section>

      <Section title="11. Children’s Privacy">
        <p>
          The AstraTrade App is not directed to children and should not be used by
          anyone under the age of majority in their jurisdiction.
        </p>
      </Section>

      <Section title="12. Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. Material changes
          will be indicated by updating the “Last updated” date.
        </p>
      </Section>

      <Section title="13. Contact">
        <p>
          For any questions or requests related to privacy: {" "}
          <a href="mailto:support@astratrade.io" className="text-blue-500 underline">
            support@astratrade.io
          </a>
          .
        </p>
      </Section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-6">
      <h2 className="text-base font-semibold mb-2">{title}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}

